import { createFileRoute } from '@tanstack/react-router';

import { grantListDeps, loadGrantList } from '../features/grants/list-loader';
import { GrantTypePage, grantTypeHead } from '../features/grants/type-page';
import { grantTypeSearch } from '../features/grants/type-search';

/**
 * `/news/programs` — 프로그램 전용 목록. 하위 종류는 `/news/programs/<slug>` (news.programs.$kind).
 *
 * 화면은 `GrantTypePage` 하나를 넷이 나눠 쓴다. 네 벌로 만들면 한쪽만
 * 고쳐지고, 그때부터 유형마다 다르게 동작하는 목록이 된다.
 */
export const Route = createFileRoute('/news/programs/')({
  validateSearch: grantTypeSearch,
  loaderDeps: ({ search }) => grantListDeps(search),
  loader: ({ context, deps }) => loadGrantList(context, deps, { support: 'program' }),
  head: () => grantTypeHead('program', '/news/programs'),
  component: () => (
    <GrantTypePage type="program" path="/news/programs" filters={Route.useLoaderDeps()} loaded={Route.useLoaderData()} />
  ),
});
